import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Common/Loading";
import PageCard from "../../Components/PageCard/PageCard";
import ProductList from "../../Components/Products/ProductList";
import { getPageByName } from "../../REDUX/actions/pages";
import { getAllProducts } from "../../REDUX/actions/products";
import { pageNames } from "../../Api/EndPoints";

const ProductsView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllProducts()); // eslint-disable-next-line
  }, []);

  return (
    <div>
      <ProductList />
    </div>
  );
};

export default ProductsView;
